import cloneDeep from 'lodash/cloneDeep';
import widgetHelper from '../widget-utilities/widget-helper';
import chartHelper from '../chart/chart-helper';
import d3Utils from '../../../utils/d3Utils';

var bubbleChartConfigBuilder = function bubbleChartConfigBuilder() {

    // Returns modified chart data
    var modifyChartData = function modifyChartData(data) {
        var dataProperties = ['data'];
        dataProperties.forEach(function (dataProperty) {
            data[dataProperty] = Object.prototype.hasOwnProperty.call(data, dataProperty) ? JSON.parse(data[dataProperty]) : null;
        });
        return data;
    };

    var modifyBubbleChartConfigProperties = function modifyBubbleChartConfigProperties(config) {
        var _config$BubbleChartCo = config.BubbleChartConfig,
            AggregationType = _config$BubbleChartCo.AggregationType,
            CrumbFieldConfig = _config$BubbleChartCo.CrumbFieldConfig,
            CrumbDisplayFieldName = _config$BubbleChartCo.CrumbDisplayFieldName,
            TipField = _config$BubbleChartCo.TipField,
            Data = config.Data;


        config.BubbleChartConfig.TipField = widgetHelper.initializeConfigPropertyWithEmptyString(TipField);

        config.BubbleChartConfig.AggregationType = chartHelper.modifyAggregationType(AggregationType);
        config.BubbleChartConfig.CrumbFieldConfig = chartHelper.modifyCrumbFieldConfig(CrumbFieldConfig);
        config.BubbleChartConfig.CrumbDisplayFieldName = chartHelper.modifyCrumbDisplayFieldName(CrumbDisplayFieldName, CrumbFieldConfig);
        config.Data = modifyChartData(Data);
        return config;
    };

    // Remove unwanted properties, add custom properties and initialize null/undefined values
    var configBuilder = function configBuilder(config) {
        // Modify common widget config properties
        config = widgetHelper.modifyWidgetConfigProperties(cloneDeep(config));

        //Modify common chart config properties
        config = modifyBubbleChartConfigProperties(cloneDeep(config));

        return config;
    };

    return {
        configBuilder: configBuilder
    };
};

export default bubbleChartConfigBuilder();